import {
  type RecommendationServiceType,
  type RecommendationWidgetType,
  useRecommendationConfigContext,
} from '../config'

export const useGetRecommendationWidgetId = (
  serviceId?: RecommendationServiceType,
  widgetType?: RecommendationWidgetType,
): string | undefined => {
  const config = useRecommendationConfigContext()
  if (!serviceId || !widgetType) {
    return undefined
  }

  return config[serviceId]?.[widgetType]?.id
}
